import React, { useRef, useEffect } from 'react';
import "./style.css"
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
ChartJS.register(...registerables);
ChartJS.register(ChartDataLabels);


const SFBarChart = ({ type, format, title, xAxisLabel, yAxisLabel, labels, dataArr, xmin, min, max, stepSize,
    practiceDataArr, isPractice, forAllStudent, labelsArr
}) => {

    const chartRef = useRef(null);

    const moveScroll = () => {
        const chart = chartRef.current;
        const {
            ctx,
            canvas,
            chartArea: { top, right, bottom, left, width, height },
            scales: { x, y },
        } = chart;

        canvas.addEventListener('click', (event) => {

            const rect = canvas.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const y = event.clientY - rect.top;
            const radius = 8;

            if (x >= left - radius && x <= left + radius &&
                y >= height / 2 + top - radius && y <= height / 2 + top + radius) {
                chart.options.scales.x.min = chart.options.scales.x.min - 1
                chart.options.scales.x.max = chart.options.scales.x.max - 1

                if (chart.options.scales.x.min <= 0) {
                    chart.options.scales.x.min = 1
                    chart.options.scales.x.max = 2
                }
            } else if (x >= right - radius && x <= right + radius &&
                y >= height / 2 + top - radius && y <= height / 2 + top + radius) {
                chart.options.scales.x.min = chart.options.scales.x.min + 1
                chart.options.scales.x.max = chart.options.scales.x.max + 1
                /* if (chart.options.scales.x.max >= data.datasets[1].data.length) {
                    chart.options.scales.x.min = data.datasets[1].data.length - 1
                    chart.options.scales.x.max = data.datasets[1].data.length
                } */

            }


            chart.update();
        })
    }

    useEffect(() => {
        moveScroll()
    }, [dataArr])

    const plugin = {
        id: 'customCanvasBackgroundColor',
        beforeDraw: (chart, args, options) => {
            const { ctx, chartArea } = chart;
            const borderRadius = options.borderRadius || 10; // Default border radius
            const { top, left, bottom, right } = chartArea;

            ctx.save();

            // Set the background color and prepare for rounded corners
            // ctx.globalCompositeOperation = 'destination-over';
            ctx.fillStyle = options.color || 'white';

            // Draw a rectangle with rounded corners
            ctx.beginPath();
            ctx.moveTo(left + borderRadius, top);
            ctx.arcTo(right, top, right, bottom, borderRadius);
            ctx.arcTo(right, bottom, left, bottom, 0);
            ctx.arcTo(left, bottom, left, top, borderRadius);
            ctx.arcTo(left, top, right, top, 0);
            ctx.closePath();
            ctx.fill();

            // Set line properties
            const lineColor = options.lineColor || 'white'; // Color of the lines
            const lineWidth = options.lineWidth || 2; // Width of the lines
            const lineSpacing = options.lineSpacing || 20; // Space between the lines

            ctx.strokeStyle = lineColor;
            ctx.lineWidth = lineWidth;

            // Draw horizontal lines from left to right inside the rounded rectangle
            for (let y = top + lineSpacing; y < bottom; y += lineSpacing) {
                ctx.beginPath();
                ctx.moveTo(left + borderRadius / 2, y); // Start inside the border radius
                ctx.lineTo(right - borderRadius / 2, y); // End inside the border radius
                ctx.stroke();
            }

            ctx.restore();
        },
    };


    const chartAreaBorder = {
        id: 'chartAreaBorder',
        beforeDraw(chart, args, options) {
            const { ctx, chartArea: { left, top, width, height } } = chart;
            const borderRadius = options.borderRadius || 10; // Default border radius

            ctx.save();
            ctx.strokeStyle = options.borderColor || 'black'; // Default border color
            ctx.lineWidth = options.borderWidth || 2; // Default border width

            // Draw only the vertical left line and horizontal bottom line with a rounded bottom-left corner
            ctx.beginPath();

            // Vertical left line
            ctx.moveTo(left, top);
            ctx.lineTo(left, top + height - borderRadius);

            // Bottom left corner with border radius
            ctx.arcTo(left, top + height, left + borderRadius, top + height, borderRadius);

            // Horizontal bottom line
            ctx.lineTo(left + width, top + height);

            ctx.stroke();
            ctx.restore();
        }
    };

    const moveChart = {
        id: "moveChart",

        afterDatasetsDraw(chart, args, pluginOptions) {
            const {
                ctx,
                canvas,
                data,
                chartArea: { top, right, bottom, left, width, height },
            } = chart;

            const angle = Math.PI / 180

            class CircleChevron {
                draw(ctx, x1, pixel, radius) {
                    // circle
                    ctx.beginPath();
                    ctx.lineWidth = 3;
                    ctx.strokeStyle = 'rgba(102, 102, 102, 0.5)';
                    ctx.fillStyle = 'white';
                    ctx.arc(x1, height / 2 + top, radius, angle * 0, angle * 360, false);
                    ctx.stroke();
                    ctx.fill();
                    ctx.closePath();

                    // chevron arrow
                    ctx.beginPath();
                    ctx.lineWidth = 2;
                    ctx.strokeStyle = '#741a76';
                    ctx.moveTo(x1 + pixel, height / 2 + top - 4);
                    ctx.lineTo(x1 - pixel, height / 2 + top);
                    ctx.lineTo(x1 + pixel, height / 2 + top + 4);
                    ctx.stroke();
                    ctx.closePath();
                }
            }

            let radius = 8;

            if (data?.labels?.length) {
                if (chart.options.scales.x.min > 1) {
                    let drawCircleLeft = new CircleChevron();
                    drawCircleLeft.draw(ctx, left, 4, radius);
                }

                if (chart.options.scales.x.max < data?.datasets[1]?.data?.length) {
                    let drawCircleRight = new CircleChevron();
                    drawCircleRight.draw(ctx, right, -4, radius);
                }
            }

        }
    }


    const options = {
        maintainAspectRatio: false,
        // skipNull: true,
        layout: {
            padding: {
                right: 10
            },
        },
        // normalized: false,
        animation: false,
        responsive: true,
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context) {
                        // Use the custom labels array for the tooltip labels
                        // console.debug("context.dataset.labels", context.dataset.labels, context.dataIndex)
                        const label = context.dataset.labels[context.dataIndex];
                        const value = context.raw;
                        return `${label}: ${value}`;
                    },
                },
            },
            legend: {
                position: 'bottom',
                display: false,
            },
            chartAreaBorder: {
                borderColor: '#484848',
                borderWidth: 3,
            },
            customCanvasBackgroundColor: {
                color: '#DFE3E5',
                lineColor: 'white',
                lineWidth: 1,
                lineSpacing: 25,
            },
            title: {
                display: false,
                text: title,
                font: {
                    size: 14, // Set the font size here
                    weight: 'bold', // Set the font weight here
                },
                color: 'black'
            },
            datalabels: {
                anchor: 'end',
                align: 'start',
                font: {
                    weight: 'bold',
                    size: 14,
                },
                formatter: (value) => {
                    // return `${value}${format}`
                    return `${value}`
                },
                color: 'white',
            },

        },
        scales: {
            x: {
                offset: true,
                title: {
                    display: true,
                    text: xAxisLabel,
                    font: {
                        size: 14,
                        weight: 600,
                        color: "black"
                    }
                },
                grid: {
                    drawBorder: false, // <-- this removes y-axis line
                    lineWidth: 0,
                },
                ticks: {
                    font: {
                        size: 10,
                    }
                },
                min: xmin,
                // max: 2,
            },
            y: {
                type: type,
                beginAtZero: true,
                grid: {
                    drawBorder: false, // <-- this removes y-axis line
                    lineWidth: 0,
                },
                title: {
                    display: true,
                    text: yAxisLabel,
                    font: {
                        size: 14,
                        weight: 600,
                        color: "black"
                    }
                },
                min: min,
                max: max,
                ticks: {
                    stepSize: stepSize,
                }
            },
        },
    }

    let datasets = [];


    if (isPractice) {
        datasets.push({
            label: 'Goal',
            data: practiceDataArr.map((value, index) => value),
            backgroundColor: 'rgba(187, 0, 0, 0.2)',
            borderRadius: 4,
            barThickness: 26,
            labels: practiceDataArr.map((_, index) => {
                return 'Goal';
            }),
        });
    } else {
        if (practiceDataArr.length > 1) {
            datasets.push({
                label: 'Goal',
                data: practiceDataArr.map((value, index) => (index === 0 ? null : value)),
                backgroundColor: 'rgba(187, 0, 0, 0.2)',
                borderRadius: 4,
                barThickness: 26,
                labels: practiceDataArr.map((_, index) => {
                    return 'Goal';
                }),
                /* categoryPercentage: 0.5,
                barPercentage: 0.2, */
            });
        }
    }


    if (isPractice) {
        datasets.push({
            label: 'Practice',
            data: dataArr,
            backgroundColor: dataArr.map((_, index) => {
                return '#FF5287';
            }),
            labels: [...dataArr, ...dataArr].map((_, index) => {
                return 'Practice';
            }),
            borderRadius: 4,
            barThickness: 40,
        });
    } else {
        datasets.push({
            label: 'Graded',
            data: dataArr,
            backgroundColor: dataArr.map((_, index) => {
                if (index === 0) {
                    return '#0077B9'; // Color for the first attempt
                }
                if (forAllStudent) {
                    return '#0077B9'; // Color for the first attempt
                }
                return '#FF5287'; // Color for subsequent attempts
            }),
            labels: dataArr.map((_, index) => {
                return index === 0 || forAllStudent ? 'Graded' : 'Practice';
            }),
            borderRadius: 4,
            barThickness: 40,
        });
    }


    let data = {
        labels,
        datasets: datasets
    };

    const barWidth = 80; // Width for each bar
    const totalBars = data?.labels?.length || 0;
    const dynamicWidth = totalBars * barWidth;

    const containerStyle = {
        width: '300px',       // Outer container fills available space
        height: '300px',
        overflowX: 'auto',
        overflowY: 'hidden',
        position: 'relative',
    };

    const chartBodyStyle = {
        width: `${dynamicWidth}px`,
        minWidth: "300px",
        height: '100%',
        position: 'relative',
    };


    console.debug("practiceDataArr", practiceDataArr)
    return (
        <div style={{ width: '300px', height: '300px' }}>
            {title}
            <div className="chart-container" style={containerStyle}>
                <div className="chart-container-body" style={chartBodyStyle}>
                    <Bar
                        ref={chartRef}
                        plugins={[ChartDataLabels, plugin, chartAreaBorder]}
                        options={options}
                        data={data}
                        height="100%"
                    />
                </div>
            </div>
        </div>


    );
}

export default SFBarChart;
